import { colors } from '@lmc/common/constants'
import { useEffect, useRef } from 'react'
import { trackEvent } from '../../../../common/services/intercom'
import { hexToRgbA } from '../../../../common/utils'
import { FamilyLogViewSettings } from '../../../../screens/AccountsSettings/FamilySettings/components'
import { OldButton } from '../../../generic'
import {
  BodyText,
  Container,
  Footer,
  FooterSubContainer,
  GreyBodyText,
  Header
} from './FamilyPortalStyles'

interface FamilyPortalItemsProps {
  fields: any
  formId: string
  goToNextStep?: () => void
  mixpanel: any // Define the type for mixpanel
}

export default function FamilyPortalItems({
  fields,
  formId,
  goToNextStep,
  mixpanel
}: FamilyPortalItemsProps) {
  const formRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (formRef.current) formRef.current.scrollIntoView()
  }, [])

  const onNext = () => {
    trackEvent('CO_family_set_items')
    mixpanel.track('CO_family_set_items')
    goToNextStep?.()
  }

  return (
    <div>
      <Container>
        <div style={{ height: 80 }} ref={formRef} />
        <Header>Family App Setup</Header>
        <BodyText>
          Customise what families will be able to view in their Apps. These
          changes will be applied to all family members you have using the
          Family App.
        </BodyText>
        <FamilyLogViewSettings homeSettings={fields} formId={formId} />
        <Footer className="lmc-fixed-footer">
          <FooterSubContainer>
            <GreyBodyText>
              Note: You can always change your settings at a later date
            </GreyBodyText>
            <OldButton
              onClick={() => onNext()}
              type="add"
              text="Next Step"
              style={{
                height: 40,
                boxShadow: `0 0 8px ${hexToRgbA(colors.black, 0.2)}`
              }}
            />
          </FooterSubContainer>
        </Footer>
      </Container>
    </div>
  )
}
